<template>
  <div>
    <v-row v-if="canApproveOrReject" justify="end" class="mb-3">
      <v-col cols="auto">
        <v-btn
          v-if="quizContent.approvalStatus !== 'REJECTED'"
          depressed
          color="error"
          min-width="120"
          class="rounded-1 ms-4"
          :loading="isRejecting"
          :disabled="isApproving"
          @click="approveOrRejectQuizContent('REJECTED')"
        >
          <v-icon left>mdi-close</v-icon>

          {{ $t("course.courseDetails.reject") }}
        </v-btn>

        <v-btn
          v-if="quizContent.approvalStatus !== 'APPROVED'"
          depressed
          color="success"
          min-width="120"
          :loading="isApproving"
          :disabled="isRejecting"
          @click="approveOrRejectQuizContent('APPROVED')"
          class="rounded-1 ms-4"
        >
          <v-icon left>mdi-check</v-icon>

          {{ $t("course.courseDetails.approve") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { approveOrRejectQuizContent } from "../../methods/approveOrRejectQuizContent";

export default {
  name: "QuizApproveOrReject",
  props: {
    quizContent: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isRejecting: false,
      isApproving: false,
    };
  },
  computed: {
    canApproveOrReject() {
      return (
        this.quizContent._id != null &&
        this.quizContent.approvalStatus === "PENDING" &&
        this.$store.state.authenticatedUserRole === "ADMIN" &&
        !this.isEditing
      );
    },
  },
  methods: {
    approveOrRejectQuizContent(approvalStatus) {
      if (this.isRejecting || this.isApproving) return;
      this.isRejecting = approvalStatus === "REJECTED";
      this.isApproving = approvalStatus === "APPROVED";

      approveOrRejectQuizContent({
        id: this.quizContent?._id,
        approvalStatus,
      }).then(response => {
        if (response.data) this.$emit("onSuccess");
        else if (response.error) this.$emit("onError");

        this.isRejecting = false;
        this.isApproving = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped />
